import { Dict } from '../../../../model/dict';
const ACTIVITY_DEFINITION_SECTOR_MAP: Dict<string[]> = {
  green: ['petrol_vehicles', 'diesel_heavy_trucks', 'ship_freight', 'unspecified_emissions_from_aviation'],
  blue: [
    'coal_usage_within_iron_and_steel_industries',
    'crude_oil_usage_within_petroleum_refinement',
    'cement_mineral_industries_coal_usage',
    'coal_usage_within_chemical_industries',
    'coal_usage_within_pulp_paper_and_print_industries',
    'prebaked_carbon_anodes_electrolysis_for_aluminium_production',
    'industrial_unregulated_coal_use',
  ],
  orange: [
    'unspecified_emissions_from_livestock',
    'unspecified_emissions_from_manure_management',
    'unspecified_emissions_from_aggregate_sources_and_non_co2_emission_sources_on_land',
  ],
  yellow: ['electricity_use_non_specified_sources', 'coal_use_non_specified_sources'],
  pink: [
    'mobile_machinery_diesel',
    'unspecified_emissions_from_product_use',
    'unspecified_emissions_from_disposal_of_solid_waste',
  ],
};

export const ACTIVITY_DEFINITION_SECTOR_MAP_REVERSE_COP_PANORAMA: Dict<string> = Object.keys(
  ACTIVITY_DEFINITION_SECTOR_MAP
).reduce((acc: { [key: string]: string }, sector) => {
  ACTIVITY_DEFINITION_SECTOR_MAP[sector].forEach((activity) => {
    acc[activity] = sector as string;
  });
  return acc;
}, {});
